import type { TPageTranslations } from '@crehana/i18n';

import { ATS_PUBLIC_CAREER_SITE } from './constants';
import type { TKeys } from './types';

export const en: TPageTranslations<TKeys, typeof ATS_PUBLIC_CAREER_SITE> = {
  [ATS_PUBLIC_CAREER_SITE]: {
    VACANCY: 'Vacancy',
    DEPARTMENT: 'Department',
    POSITION: 'Position',
    CLOSED_DATE: 'Closed date',
    PUBLISHED_DATE: 'Published {{days}}',
    SEARCH_BY_NAME: 'Search by name',
    DAY: 'day',
    MONTH: 'month',
    YEAR: 'year',
    DAYS: 'days',
    MONTHS: 'months',
    YEARS: 'years',
    CLOSED_DATE_CARD: 'Closed date: {{date}}',
    FILTER_BY: 'Filter by',
    SEARCH_BY_DEPARTMENT: 'Search by department',
    NO_DEPARTMENTS_FOUND: 'No departments found',
    TRY_ANOTHER_SEARCH: 'Try another search',
    VACANCY_EXAMPLE: 'Vacancy example',
    OPEN_DATE_EXAMPLE: 'Published 3 days ago',
    DEPARTMENT_EXAMPLE: 'Department example',
    RETRY: 'Retry',
    ERROR_PAGE_TITLE_CAREER_SITE: 'Error loading career site',
    ERROR_PAGE_DESCRIPTION_CAREER_SITE:
      'An unexpected error occurred. Please try again.',
    CAREER_SITE_STATUS_TITLE_NOT_FOUND: 'Career site not found',
    CAREER_SITE_STATUS_DESCRIPTION_NOT_FOUND:
      'The career site you are looking for does not exist or has been removed.',
  },
};
